import actionTypes from "../../constants/action-types";

const participantProductReducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.participantProduct.REQUEST: {
            return {
                ...state,
                isAuthenticating: true
            };
        }
        case actionTypes.participantProduct.LIST_SUCCESS: {
            return {
                ...state,
                isAuthenticating: false,
                productList: action.response.data
            }
        }
        case actionTypes.participantProduct.LIST_FAILURE: {
            return {
                ...state,
                error: action.error,
                isAuthenticating: false
            }
        }
        case actionTypes.participantProduct.DETAIL_SUCCESS: {
            return {
                ...state,
                isAuthenticating: false,
                product: action.product
            }
        }
        case actionTypes.participantProduct.DETAIL_FAILURE: {
            return {
                ...state,
                error: action.error,
                isAuthenticating: false
            }
        }
        case actionTypes.participantProduct.CLEAR_PRODUCT_DETAIL: {
            return {
                ...state,
                product: {}
            }
        }
        default:
            return state;
    }
}

export default participantProductReducer;
